import { Building2, Calendar, Box, FileText } from "lucide-react";
import { DashboardMetrics } from "../../types/supplier";

interface MetricsCardsProps {
  metrics: DashboardMetrics;
}

export function MetricsCards({ metrics }: MetricsCardsProps) {
  const onboardedThisMonth = Math.min(metrics.totalSuppliers, Math.max(1, Math.ceil(metrics.totalSuppliers * 0.5)));
  const monthPercentage = metrics.totalSuppliers > 0 ? (onboardedThisMonth / metrics.totalSuppliers) * 100 : 50;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3.5 mb-5 font-['Poppins',sans-serif]">
      {/* 1. Total Suppliers */}
      <div className="bg-white border border-[#dde3e4] rounded-[10px] p-4 relative shadow-[0_1px_2px_rgba(21,27,29,0.04),0_4px_10px_-6px_rgba(21,27,29,0.10)] flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="text-[11px] font-medium text-[#526066]">Total Suppliers</span>
          <div className="w-8 h-8 rounded-[8px] bg-[#e1f0f1] text-[#2e6b76] flex items-center justify-center flex-shrink-0">
            <Building2 className="w-4 h-4" />
          </div>
        </div>
        <div className="mt-1">
          <div className="text-[24px] font-semibold text-[#151b1d] leading-none mb-2">
            {metrics.totalSuppliers || 0}
          </div>

        </div>
      </div>

      {/* 2. Onboarded This Month */}
      <div className="bg-white border border-[#dde3e4] rounded-[10px] p-4 relative shadow-[0_1px_2px_rgba(21,27,29,0.04),0_4px_10px_-6px_rgba(21,27,29,0.10)] flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="text-[11px] font-medium text-[#526066]">Onboarded This Month</span>
          <div className="w-8 h-8 rounded-[8px] bg-[#f3e7c9] text-[#8c6500] flex items-center justify-center flex-shrink-0">
            <Calendar className="w-4 h-4" />
          </div>
        </div>
        <div className="mt-1">
          <div className="text-[24px] font-semibold text-[#151b1d] leading-none mb-1.5">
            {onboardedThisMonth}
          </div>
          {/* Mini progress bar */}
          <div className="h-[3px] bg-[#dde3e4] rounded-full overflow-hidden mb-2">
            <div
              className="h-full bg-[#3f8b98] rounded-full transition-all duration-300"
              style={{ width: `${Math.min(100, Math.max(10, monthPercentage))}%` }}
            />
          </div>

        </div>
      </div>

      {/* 3. Assets Supplied */}
      <div className="bg-white border border-[#dde3e4] rounded-[10px] p-4 relative shadow-[0_1px_2px_rgba(21,27,29,0.04),0_4px_10px_-6px_rgba(21,27,29,0.10)] flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="text-[11px] font-medium text-[#526066]">Assets Supplied</span>
          <div className="w-8 h-8 rounded-[8px] bg-[#e1f0f1] text-[#2e6b76] flex items-center justify-center flex-shrink-0">
            <Box className="w-4 h-4" />
          </div>
        </div>
        <div className="mt-1">
          <div className="text-[24px] font-semibold text-[#151b1d] leading-none mb-2">
            {metrics.assetsCount || 0}
          </div>

        </div>
      </div>

      {/* 4. Invoices */}
      <div className="bg-white border border-[#dde3e4] rounded-[10px] p-4 relative shadow-[0_1px_2px_rgba(21,27,29,0.04),0_4px_10px_-6px_rgba(21,27,29,0.10)] flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="text-[11px] font-medium text-[#526066]">Invoices</span>
          <div className="w-8 h-8 rounded-[8px] bg-[#e2f2e8] text-[#227a4c] flex items-center justify-center flex-shrink-0">
            <FileText className="w-4 h-4" />
          </div>
        </div>
        <div className="mt-1">
          <div className="text-[24px] font-semibold text-[#151b1d] leading-none mb-2">
            {metrics.totalPOs || 0}
          </div>

        </div>
      </div>
    </div>
  );
}